import React, { useState } from 'react';
import { ui } from './toolTheme';
const API_BASE = process.env.REACT_APP_API_BASE || '';

const QrBarcodePage = ({ setPage }) => {
  const [text, setText] = useState('https://syncusive.com');
  const [qrUrl, setQrUrl] = useState('');
  const [scanFile, setScanFile] = useState(null);
  const [scanRes, setScanRes] = useState('');
  const [barcodeText, setBarcodeText] = useState('123456789012');
  const [barcodeUrl, setBarcodeUrl] = useState('');
  const [err, setErr] = useState('');

  const qrGenerate = async () => {
    setErr('');
    try {
      const res = await fetch(`${API_BASE}/api/qr/generate`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ text }) });
      if (!res.ok) throw new Error((await res.json().catch(()=>({}))).error || 'Failed');
      const blob = await res.blob(); setQrUrl(URL.createObjectURL(blob));
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  const qrScan = async () => {
    if (!scanFile) return;
    setErr(''); setScanRes('');
    try {
      const fd = new FormData(); fd.append('file', scanFile);
      const res = await fetch(`${API_BASE}/api/qr/scan`, { method:'POST', body: fd });
      const data = await res.json(); if (!res.ok) throw new Error(data.error || 'Failed');
      setScanRes((data.values || []).join(', ') || '(empty)');
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  const barcodeGenerate = async () => {
    setErr('');
    try {
      const res = await fetch(`${API_BASE}/api/barcode/generate`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ text: barcodeText }) });
      if (!res.ok) throw new Error((await res.json().catch(()=>({}))).error || 'Failed');
      const blob = await res.blob(); setBarcodeUrl(URL.createObjectURL(blob));
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  return <main style={ui.page}><div style={ui.container}>
    <button onClick={()=>setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
    <div style={ui.card}><h1 style={ui.sectionTitle}>QR + Barcode Tools</h1></div>
    <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginTop:14}}>
      <div style={ui.card}>
        <h3 style={{color:'#cbd5e1'}}>Generate QR</h3>
        <input value={text} onChange={(e)=>setText(e.target.value)} style={ui.input} />
        <button onClick={qrGenerate} style={{...ui.primaryBtn, marginTop:8}}>Generate</button>
        {qrUrl && <img src={qrUrl} alt='qr' style={{marginTop:10, maxWidth:'100%'}} />}
      </div>
      <div style={ui.card}>
        <h3 style={{color:'#cbd5e1'}}>Scan QR</h3>
        <input type='file' accept='image/*' onChange={(e)=>setScanFile(e.target.files?.[0]||null)} style={ui.fileInput} />
        <button onClick={qrScan} style={{...ui.primaryBtn, marginTop:8}}>Scan</button>
        {scanRes && <div style={ui.success}>{scanRes}</div>}
      </div>
      <div style={ui.card}>
        <h3 style={{color:'#cbd5e1'}}>Generate Barcode</h3>
        <input value={barcodeText} onChange={(e)=>setBarcodeText(e.target.value)} style={ui.input} />
        <button onClick={barcodeGenerate} style={{...ui.primaryBtn, marginTop:8}}>Generate</button>
        {barcodeUrl && <img src={barcodeUrl} alt='barcode' style={{marginTop:10, maxWidth:'100%'}} />}
      </div>
    </div>
    {err && <div style={ui.error}>{err}</div>}
  </div></main>;
};

export default QrBarcodePage;
